// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14331":"32c50f79","92151":"ec6c48ff"}[chunkId] + ".chunk.css";
};